import Module from './puppyQuizResult'
export default Module
